import { Grid, Typography, makeStyles, Theme } from '@material-ui/core';
import { observer } from 'mobx-react';
import { FileUploadArea, UploadedDocument, FileUpload } from '@roc/ui';
import { useStore } from '@roc/client-portal-shared/hooks';

const useStyles = makeStyles((theme: Theme) => ({
  sectionLabel: {
    fontWeight: 700,
    marginBottom: theme.spacing(1),
  },
}));

export const DocReviewUploader = observer(() => {
  const { docReviewStoreV2, documentStore } = useStore();
  const document = docReviewStoreV2.document;
  const uploadLocked = docReviewStoreV2.isUploadLocked(document);

  const handleReupload = async (file: File) => {
    await documentStore.uploadDocument(file, document, document.loanProcess);
    await docReviewStoreV2.getReviewTaskData(document.taskId);
    docReviewStoreV2.setProcessingStatus('IN_PROGRESS');
  };

  const handleSetFiles = (updater: FileUpload[] | ((prev: FileUpload[]) => FileUpload[])) => {
    const resolved = typeof updater === 'function' ? updater([]) : updater;
    const file = resolved[0]?.file;
    if (file) handleReupload(file);
  };

  return document?.dropboxPath ? (
    <UploadedDocument
      document={document}
      onUpload={uploadLocked ? undefined : handleReupload}
      disabled={docReviewStoreV2.processingStatus === 'IN_PROGRESS'}
    />
  ) : (
    <FileUploadArea items={[]} setItems={handleSetFiles} />
  );
});

// the uploader every document gets unless it has its own
export const DefaultDocReviewUploader = observer(() => {
  const classes = useStyles();
  const { docReviewStoreV2 } = useStore();
  const document = docReviewStoreV2.document;
  return (
    <Grid item xs={12}>
      <Typography className={classes.sectionLabel}>
        Upload{document?.dropboxPath ? 'ed' : ''} Document
      </Typography>
      <DocReviewUploader />
    </Grid>
  );
});
